import ApiService from "@/utils/request";
export const wmsApi = {
    // 视频流接口
    //货架运行状态
    getInfoBySlotCode: (slotCode) => ApiService.get(`/wms/stat/slot/all/list?slotCode=${slotCode}`),
};
